import { PresentationBundleKind } from '@/types/schema';

import { BundleSaveDescriptor } from '../presentationSave.types';
import { createGeneratedBundleCardDescriptor } from './generatedBundleCardDescriptor';

export const powerOfAttorneyBundleDescriptor: BundleSaveDescriptor =
  createGeneratedBundleCardDescriptor({
    kind: PresentationBundleKind.PowerOfAttorneyBundle,
    field: 'powerOfAttorneyBundleConfiguration',
    read: (bundle) => {
      const config = bundle.powerOfAttorneyBundleConfiguration;
      if (!config) return undefined;
      return {
        id: config.id,
        displayName: config.displayName,
        itemsPerPage: config.itemsPerPage,
        cards: config.powersOfAttorney.map((powerOfAttorney) => ({
          id: powerOfAttorney.id,
          name: powerOfAttorney.grantorName,
          items: powerOfAttorney.items,
        })),
      };
    },
  });
